<template>
  <div>
    <div class="row mt-5">
      <div class="col text-center">
        <h5>
          <b>{{cooperado.nome}}</b>
        </h5>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col">
        <div
          class="alert alert-warning"
          role="alert"
          v-if="data.length === 0"
        >Nenhum registro cadastrado.</div>

        <div id="accordion">
          <div class="card" v-for="item in data" :key="item._id">
            <div
              class="card-header"
              :id="'H' + item._id"
              data-toggle="collapse"
              :data-target="'#D' + item._id"
            >
              <div class="row">
                <div class="col-1">
                  <i
                    class="material-icons icone"
                    :class="verificaValidade(item).classes"
                  >report_problem</i>
                </div>

                <div class="col-6">
                  {{item.documento}} /
                  {{item.tipoLicenca}} /
                  {{item.atividade}}
                  <br />
                  <span v-if="!ehProtocolo(item)">
                    {{item.licenca ? verificaValidade(item).diff + ' dias para vencer' : ''}}
                    <br />
                    <small
                      v-if="item.protocolado"
                      :class="verificaValidade(item).classes"
                    >protocolado {{verificaValidade(item).diffProtocolado}} dias antes do vencimento</small>
                  </span>
                </div>
                <div class="col-5" v-if="!token.somenteLeitura">
                  <a
                    href="javascript:;"
                    data-toggle="modal"
                    data-target="#protocolarModal"
                    @click="form.documento = item.documento;form._id = item._id"
                    v-if="!ehProtocolo(item)"
                  >
                    Protocolar
                    /
                  </a>
                  <a
                    @click="form.arquivoToDelete = item"
                    href="#"
                    data-toggle="modal"
                    data-target="#confirmModal"
                    class="danger"
                  >Remover arquivo /</a>
                  <router-link title="Alterar" :to="`${route}/edit/${item._id}`">Atualizar Arquivo</router-link>/
                  <router-link title="Alterar" :to="`${route}/edit/${item._id}/over`">Substituir</router-link>
                </div>
              </div>
            </div>

            <div :id="'D'+item._id" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td>
                        <b>Licença: {{item.documento}} - {{item.tipoLicenca}}</b>
                      </td>
                      <td>
                        <b
                          v-if="!ehProtocolo(item)"
                        >{{item.licenca ? 'Validade:' + formata(item.validade) : formata(item.data)}}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a
                          class="btn btn-sm btn-raised btn-primary btn-block"
                          v-if="item.filename"
                          target="_blank"
                          :href="`${api}/api/v1${route}/doc/${item.filename}?token=${jwt}&mimetype=${item.mimetype}&original=${item.originalname}`"
                        >Download Licença</a>
                        <span v-if="!item.filename">Nenhum</span>
                      </td>
                      <td>
                        <button
                          v-if="!ehProtocolo(item) && !token.somenteLeitura"
                          type="button"
                          class="btn btn-sm btn-warning btn-block btn-raised"
                          data-toggle="modal"
                          data-target="#protocolarModal"
                          @click="form.documento = item.documento;form._id = item._id"
                        >+ Protocolar</button>
                      </td>
                    </tr>
                    <tr v-if="item.protocolado">
                      <td>
                        Protocolo: {{item.numeroProtocolo}}
                        <br />
                        Data: {{formata(item.data)}}
                      </td>
                      <td>
                        <a
                          class="btn btn-sm btn-block btn-secondary btn-raised"
                          v-if="item.arquivoProtocolo && item.arquivoProtocolo.filename"
                          target="_blank"
                          :href="`${api}/api/v1${route}/doc/${item.arquivoProtocolo.filename}?token=${jwt}&mimetype=${item.arquivoProtocolo.mimetype}&original=${item.arquivoProtocolo.originalname}`"
                        >Download Protocolo</a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <hr />
                <form>
                  <div class="row">
                    <div class="col">
                      <h5>Condicionantes</h5>
                      <div class="input-group-prepend mr-3" v-if="!token.somenteLeitura">
                        <button
                          @click="addCondicionante(item)"
                          class="btn btn-raised btn-success fundoverde"
                          type="button"
                        >+</button>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-2 col-sm-12">Título</div>
                    <div class="col-md-2 col-sm-12">Vencimento</div>
                    <div class="col-md-2 col-sm-12">Primeiro Alerta</div>
                    <div class="col-md-2 col-sm-12">Concluído Em</div>
                    <div class="col-md-2 col-sm-12">Repetir?</div>
                    <div class="col-md-1 col-sm-12">Anexos</div>
                    <div class="col-md-1 col-sm-12">Remover</div>
                  </div>

                  <div
                    v-for="(condicionante, index) in item.condicionantes"
                    :key="condicionante.ordem"
                  >
                    <div class="row" v-if="condicionante.ativo">
                      <div class="col-md-2 col-sm-12">
                        <div class="input-group">
                          <input type="text" class="form-control" v-model="condicionante.titulo" />
                        </div>
                      </div>

                      <div class="col-md-2 col-sm-12">
                        <input type="date" class="form-control" v-model="condicionante.vencimento" />
                      </div>

                      <div class="col-md-2 col-sm-12">
                        <input
                          type="date"
                          class="form-control"
                          v-model="condicionante.primeiroAlerta"
                        />
                      </div>

                      <div class="col-md-2 col-sm-12">
                        <input type="date" class="form-control" v-model="condicionante.concluidoEm" />
                      </div>

                      <div class="col-md-2 col-sm-12">
                        <select v-model="condicionante.periodicidade" class="form-control">
                          <option value="1">Mensal</option>
                          <option value="2">Bimestral</option>
                          <option value="3">Trimestral</option>
                          <option value="6">Semestral</option>
                          <option value="12">Anual</option>
                          <option value="24">Bianual</option>
                        </select>
                      </div>

                      <div class="col-md-1 col-sm-12">
                        <vue-dropzone
                          :ref="'condicionante' + index + item._id"
                          :id="'condicionante' + index + item._id"
                          :options="dropzoneOptionsCond"
                          v-on:vdropzone-success="(file, res) => updateDocCond(condicionante, 'condicionante' + index + item._id, res)"
                        ></vue-dropzone>
                      </div>

                      <div class="col-md-1 col-sm-12">
                        <button
                          @click="removeCondicionante(item, index)"
                          class="btn btn-raised btn-danger"
                          type="button"
                        >-</button>
                      </div>

                      <div
                        class="col-md-12"
                        v-for="(anexo, idxA) in condicionante.anexos"
                        :key="anexo.filename"
                      >
                        <a
                          target="_blank"
                          :href="`${api}/api/v1${route}/doc/${anexo.filename}?token=${jwt}&mimetype=${anexo.mimetype}&original=${anexo.originalname}`"
                        >{{anexo.originalname}}</a>
                        <span class="text-danger" @click="removeFileAnexo(task, idxA)">
                          <i class="material-icons">delete</i>
                        </span>
                      </div>
                    </div>
                    <div class="row" v-if="condicionante.ativo">
                      <div class="col-md-12 col-sm-12">
                        <label for="alerta">Alerta para:</label>
                        <select v-model="condicionante.email" class="form-control">
                          <option
                           v-for="c in cooperados"
                          :key="c._id"
                           :value="c.email">{{c.login}}</option>
                        </select>
                      </div>
                    </div>
                    <hr>
                    <br>
                    <br>
                  </div>

                  <div class="row mt-4" v-if="!token.somenteLeitura">
                    <div class="col">
                      <button
                        @click="saveCondicionantes(item)"
                        type="button"
                        class="btn btn-success btn-raised"
                      >Salvar tudo</button>
                      <button
                        @click="makeDefault(item)"
                        type="button"
                        class="btn btn-info btn-raised"
                      >Tornar essa listagem padrão</button>
                      <button
                        @click="loadDefault(item)"
                        type="button"
                        class="btn btn-info btn-raised"
                      >Carregar condicionantes padrão</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col">
        <pagination :records="total" :options="pagOpts" :per-page="perPage" @paginate="setPage"></pagination>
      </div>
    </div>

    <div
      class="modal fade"
      id="protocolarModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Protocolar Licença {{form.documento}}
              <br />
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="numeroProtocolo" class="col-form-label">Número protocolo</label>
                <input
                  type="text"
                  v-model="form.numeroProtocolo"
                  class="form-control"
                  id="numeroProtocolo"
                />
              </div>
              <div class="form-group" v-show="!form.licenca">
                <label for="data">Data</label>
                <input v-model="form.data" id="data" type="date" class="form-control" />
              </div>
              <vue-dropzone
                ref="doc"
                id="doc"
                :options="dropzoneOptions"
                v-on:vdropzone-success="updateDoc"
              ></vue-dropzone>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-raised mr-2"
              data-dismiss="modal"
            >Cancelar</button>
            <button
              type="button"
              class="btn btn-primary btn-raised"
              @click="adicionarProtocolo()"
            >Protocolar</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="confirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalConfirmLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Remover arquivo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group" v-if="form.arquivoToDelete">
                <label for="numeroProtocolo" class="col-form-label">Dados do arquivo:</label>
                {{form.arquivoToDelete.licenca ? 'Licença': 'Protocolo'}} /
                {{form.arquivoToDelete.documento}} /
                {{form.arquivoToDelete.licenca ? verificaValidade(form.arquivoToDelete).diff + ' dias para vencer' : ''}}
              </div>
            </form>
          </div>
          <div class="alert alert-danger mr12-12" role="alert">Tem certeza que deseja excluir?</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-raised mr-2"
              data-dismiss="modal"
            >Cancelar</button>
            <button
              type="button"
              class="btn btn-danger btn-raised"
              @click="removeFile(form.arquivoToDelete)"
            >Excluir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ls from "local-storage";
import moment from "moment";
import vueDropzone from "vue2-dropzone";

export default {
  components: {
    vueDropzone
  },
  data() {
    return {
      cooperado: {},
      data: [],
      cooperados: [],
      route: "/compromissos/ambientais",
      page: 1,
      perPage: 10,
      total: 0,
      pagOpts: this.$custom.pagOpts,
      form: {
        arquivoToDelete: {},
        numeroProtocolo: "",
        data: moment().format("YYYY-MM-DD"),
        documento: "",
        _id: "",
        arquivoProtocolo: {
          mimetype: "",
          filename: "",
          originalname: ""
        }
      },
      dropzoneOptions: this.$http.getDropzoneConfig(
        `/compromissos/ambientais/upload`,
        "post",
        {
          maxFiles: 1,
          addRemoveLinks: true,
          capture: true,
          dictDefaultMessage: "Clique ou arraste arquivos aqui para UPLOAD",
          dictRemoveFile: "Remover"
        }
      ),
      dropzoneOptionsCond: this.$http.getDropzoneConfig(
        "/compromissos/ambientais/upload",
        "post",
        {
          maxFiles: 1,
          thumbnailWidth: 50,
          capture: true,
          dictDefaultMessage: '<i class="material-icons">attach_file</i>',
          createImageThumbnails: false
        }
      )
    };
  },
  methods: {
    ehProtocolo(item) {
      if (
        item.tipoLicenca.indexOf("PROTOCOLO") > -1 ||
        item.tipoLicenca === "PARS"
      ) {
        return true;
      }

      return false;
    },
    loadDefault(item) {
      if (
        confirm(
          "Deseja carregar a lista padrão de condicionantes? Essa ação não poderá ser desfeita."
        )
      ) {
        this.$http
          .get(`${this.route}/getcondicionantespadrao`)
          .then(response => {
            if (response.data.success) {
              item.condicionantes = response.data.condicionantes;
              this.$toasted.show(
                "Modelo padrão carregado com sucesso!",
                this.$custom.success
              );
            } else {
              this.$toasted.show(
                "Ocorreu um erro, tente novamente!",
                this.$custom.error
              );
            }
          });
      }
    },
    makeDefault(item) {
      if (
        confirm(
          "Deseja tornar a lista atual de condicionantes na lista padrão? Essa ação não poderá ser desfeita."
        )
      ) {
        this.$http
          .post(`${this.route}/updatepadraocondicionantes`, item)
          .then(response => {
            if (response.data.success) {
              this.$toasted.show(
                "Modelo padrão atualizado com sucesso!",
                this.$custom.success
              );
            } else {
              this.$toasted.show(
                "Ocorreu um erro, tente novamente!",
                this.$custom.error
              );
            }
          });
      }
    },
    saveCondicionantes(item) {
      this.$http
        .post(`${this.route}/savecondicionantes`, item)
        .then(response => {
          if (response.data.success) {
            this.$toasted.show(
              "Licença atualizada com sucesso!",
              this.$custom.success
            );
          } else {
            this.$toasted.show(
              "Ocorreu um erro, tente novamente!",
              this.$custom.error
            );
          }
        });
    },
    reordenar(item) {
      for (let i = 0; i < item.condicionantes.length; i++) {
        const condicionante = item.condicionantes[i];
        condicionante.ordem = i;
      }
    },
    removeCondicionante(item, index) {
      if (confirm("Deseja remover essa condicionante?")) {
        item.condicionantes.splice(index, 1);
        this.reordenar(item);
      }
    },
    addCondicionante(item) {
      item.condicionantes.push({
        ordem: item.condicionantes.length,
        titulo: "",
        vencimento: "",
        primeiroAlerta: "",
        periodicidade: "1",
        concluidoEm: "",
        ativo: true,
        anexos: []
      });
    },
    verificaValidade(item) {
      const hojeProtocolado = moment(item.data);
      const hoje = moment();
      const ate = moment(item.validade);

      let diff = ate.diff(hoje, "days");
      let diffProtocolado = ate.diff(hojeProtocolado, "days");

      if (diff < 0) diff = 0;
      if (diffProtocolado < 0) diffProtocolado = 0;
      console.log(item.tipoLicenca);
      let min = 120;
      let max = 150;
      if (
        item.tipoLicenca === "SERFLOR" ||
        item.tipoLicenca === "POLICIA FEDERAL" ||
        item.tipoLicenca === "CERTIFICADO CORPO BOMBEIROS (CVCB)" ||
        item.tipoLicenca === "CREA" ||
        item.tipoLicenca === "ALVARÁ" ||
        item.tipoLicenca === "ALVARÁ LOCALIZAÇÃO" ||
        item.tipoLicenca === "AUTORIZAÇÃO TRANSPORTE IBAMA" ||
        item.tipoLicenca === "ALVARÁ SANITÁRIO" ||
        item.tipoLicenca === "OUTRO" ||
        item.tipoLicenca === "AA"
      ) {
        min = 1;
        max = 30;
      }

      if (
        item.tipoLicenca === "CTF IBAMA"
      ) {
        min = 1;
        max = 5;
      }

      if (item.tipoLicenca.indexOf("OUTORGA") > -1 || item.tipoLicenca === "ADAPAR") {
        min = 90;
        max = 150;
      }

      return {
        classes: {
          amarelo: item.licenca && diff >= min && diff <= max,
          verde: item.licenca && diff > max,
          verdeProtocolo: item.protocolado && diffProtocolado >= min,
          vermelhoProtocolo: item.protocolado && diffProtocolado < min,
          vermelho: item.licenca && diff < min
        },
        diff,
        diffProtocolado
      };
    },
    async removeFile(doc) {
      const res = await this.$http.delete(`${this.route}/${doc._id}`);
      for (let i = 0; i < this.data.length; i++) {
        const el = this.data[i];
        if (el._id === doc._id) {
          this.data.splice(i, 1);
        }
      }
      $("#confirmModal").modal("hide");
    },
    formata(data) {
      return moment(data).format("DD/MM/YYYY");
    },
    setPage: function(page) {
      this.page = page;

      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;

      let url = `${this.route}/list/${this.$route.params.id}`;

      this.$http.post(url, { skip, limit }).then(response => {
        this.data = response.data.data;

        for (let i = 0; i < this.data.length; i++) {
          const item = this.data[i];
          for (let j = 0; j < item.condicionantes.length; j++) {
            const t = item.condicionantes[j];

            if (t.vencimento) {
              t.vencimento = moment(t.vencimento).format("YYYY-MM-DD");
            }

            if (t.primeiroAlerta) {
              t.primeiroAlerta = moment(t.primeiroAlerta).format("YYYY-MM-DD");
            }

            if (t.concluidoEm) {
              t.concluidoEm = moment(t.concluidoEm).format("YYYY-MM-DD");
            }
          }
        }

        this.total = response.data.total;
      });
    },
    updateDoc(file, response) {
      this.form.arquivoProtocolo.mimetype = response.mimetype;
      this.form.arquivoProtocolo.filename = response.filename;
      this.form.arquivoProtocolo.originalname = response.originalname;
    },
    updateDocCond(condicionante, ref, response) {
      condicionante.anexos.push({
        mimetype: response.mimetype,
        filename: response.filename,
        originalname: response.originalname
      });

      const dpRef = this.$refs[ref];
      dpRef[0].removeAllFiles();
    },
    adicionarProtocolo() {
      this.$http.post(`${this.route}/protocolar`, this.form).then(response => {
        this.form = {
          numeroProtocolo: "",
          documento: "",
          data: moment().format("YYYY-MM-DD"),
          _id: "",
          arquivoProtocolo: {
            mimetype: "",
            filename: "",
            originalname: ""
          }
        };

        this.$refs.doc.removeAllFiles(true);

        $("#protocolarModal").modal("hide");
        this.setPage(this.page);
      });
    }
  },
  async beforeMount() {
    this.setPage(1);
    const cooperado = await this.$http.get(`/usuario/${this.$route.params.id}`);
    this.cooperado = cooperado.data;

    const cooperados = await this.$http.post(`/residuos/coleta/cooperados`);
    const soComEmail = [];

    for (let i = 0; i < cooperados.data.length; i++) {
      const c = cooperados.data[i];
      if (c.email) soComEmail.push(c);
    }

    this.cooperados = soComEmail;
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}

.dropzone,
.dropzone > div {
  min-height: 0px !important;
  padding: 0px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/app/compromissos/ambientais/AmbientalCooperado.vue